// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"BAButton--next-sr-only--21HTu20","BAButton":"BAButton--BAButton--199qPnr","BAButtonShow":"BAButton--BAButtonShow--PaxIqDk","ItemText":"BAButton--ItemText--2rTFXW6"};